export default class Distribution {
    constructor (dto) {
        this.documents = [];
        this.autoFinish = false;
        this.notifyDistributor = false;
        this.notifyByEmail = false;
        this.details = [];
        this.isInternal = false;

        if (dto) {
            this.documents = dto.map(x => parseInt(x));
        }
    }

    toDto () {
        return {
            ObjectIDs: this.documents,
            AutoFinish: this.autoFinish,
            NotifyByEmail: this.notifyByEmail,
            NotifyDistributor: this.notifyDistributor,
            IsInternal: this.isInternal,
            Details: this.details.map(x => x.toDto()),
        };
    }
}
